/**
 * PaymentTypesSection Component
 * 
 * Payment types configuration section with selectable chips
 */

import React from 'react';
import type { PaymentTypeOption } from '../../components/utils/utils';
import './PaymentTypesSection.scss';

interface PaymentTypesSectionProps {
  paymentTypes: PaymentTypeOption[];
  selectedPaymentTypes: Set<number>;
  onTogglePaymentType: (id: number) => void;
}

const PaymentTypesSection: React.FC<PaymentTypesSectionProps> = ({
  paymentTypes,
  selectedPaymentTypes,
  onTogglePaymentType,
}) => {
  return (
    <div className="settings-card">
      <h4>Tipos de Pagos</h4>
      <div className="payment-types-grid">
        {paymentTypes.map((type) => (
          <div
            key={type.id}
            className={`payment-chip ${
              selectedPaymentTypes.has(type.id) ? 'active' : ''
            }`}
            id={`payment-type-${type.id}`}
            onClick={() => onTogglePaymentType(type.id)}
          >
            <span>{type.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentTypesSection;